import styled from 'styled-components';

import { grey2 } from 'approot/shared/styles/colours.style';
import { ImagePicture } from 'approot/shared/images/images.style';

export const ComponentImageContainer = styled(ImagePicture)`
  ${({ $imageHasLoaded }) =>
    !$imageHasLoaded &&
    `
    background-color: ${grey2};
  `}
`;
